<template>
    <div>
        <div class="align-center">
        <div class="uk-grid-divider justify-center" uk-grid>
            <div>
                        <a v-if="counter > 0" href="#" class="uk-icon-button" uk-icon="arrow-left" @click="counter-=1"></a>
            </div>
            <div>
                        <a v-if="counter < documents.length" href="#" class="uk-icon-button" uk-icon="arrow-right" @click="counter+=1"></a>
            </div>
        </div>
        </div>
        <p>Total Surveys: {{documents.length}}</p>
        <button class="uk-button-primary cursor-pointer" @click="pdfDoc">PDF THIS</button>
<!--other information-->

        <div v-if="documents" class="uk-card uk-card-secondary uk-card-body survey-card">
            <a class="uk-button uk-button-link uk-card-title" :href="'/dashboard/' + link[0].value.slug + '/'">{{link[0].value.display_name}}</a>
            <div class="uk-grid-collapse justify-center" uk-grid>
                <div>
                    <table class="uk-table uk-table-hover uk-table-striped ops-table">
                        <tbody>
                        <div>
                            <tr v-for="q, i in evenMetric">
                                <td>
                                    {{q.metaData.question}}
                                </td>
                                <td>
                                    {{q.value}}
                                </td>
                            </tr>
                        </div>
                        </tbody>
                    </table>
                </div>
                <div>
                    <table class="uk-table uk-table-hover uk-table-striped ops-table">
                        <tbody>
                        <div>
                            <tr v-for="q, i in oddMetric">
                                <td>
                                    {{q.metaData.question}}
                                </td>
                                <td>
                                    {{q.value}}
                                </td>
                            </tr>
                        </div>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


<!--            choice questions-->
            <div v-for="q, idx in choiceParentQuestion" class="uk-card uk-card-default uk-card-body survey-card">
                <h3 >{{q.metaData.question}}</h3>
<!--                <h3>{{childQuestions(q)}}</h3>-->
            <table class="uk-table" v-if="q.value !=undefined">
                <thead>
                <tr>
                    <th :class="{'highlight-cell': a==q.value, 'question_option':true} " v-for="a in sort_question_options(q.metaData.question_options)">
                        {{a}}
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td v-for="a in sort_question_options(q.metaData.question_options)">
                        <span v-if="a != q.value" uk-icon="close"></span>
                        <span v-else uk-icon="check"></span>
                    </td>
                </tr>
                </tbody>
            </table>
                <div v-if="childQuestions(q).length > 0">
                    <table class="uk-table uk-table-divider uk-table-striped uk-table-small">
                        <tbody>
                            <tr v-for="q in childQuestions(q)">
                                <td style="text-align:left">{{q.metaData.question}}</td>
                                <td style="text-align:right">{{q.value}}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div v-if="q.value == undefined">
                    <h3>Left Blank</h3>
                </div>

            </div>

<!--            open-questions-->
            <div v-for="q, idx in openResponse" class="uk-card uk-card-default uk-card-body survey-card">
                <h3 >{{q.metaData.question}}</h3>
                <p>{{q.value}}</p>

            </div>

        </div>


</template>

<script>

    import pdfMake from 'pdfmake/build/pdfmake.js'
    import pdfFonts from 'pdfmake/build/vfs_fonts.js'
    // var pdfMake = require('pdfmake/build/pdfmake.js');
    // var pdfFonts = require('pdfmake/build/vfs_fonts.js');
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    import Moment from 'moment'

    export default {
        name: "GeneratedDocument",
        props: ['documents'],
        data: function() {
            return {
                counter: 0,
                noData: true,
                reverse: true,
                name: "Surveys",
            }
        },
        methods: {
            formatQuestion(question, question_type) {

            },

            sort_question_options: function(question_options){
                if (question_options[1] == 'Totally Dissatisfied'){
                    question_options={
                        1:'Totally Satisfied',
                        2:'Satisfied',
                        3:'Neither Satisfied nor Dissatisfied',
                        4:'Dissatisfied',
                        5:'Totally Dissatisfied',
                        6:'Cant Say'
                    }
                }
                return question_options
            },
            childQuestions: function(q){

                let output = this.document.filter(document => document.metaData.parent==q.metaData.id)
                console.log(q.metaData.id, output)
                return output
            },
            pdfDoc: function () {
                let _t = this;
                let table_widths = [];
                let columns = ['field', 'value']
                let pdf_table = [];
                var docDefinition = {
                    header: {
                        margin: 10,
                        columns: [
                            {
                                margin: [10, 0, 0, 0],
                                text: Moment().format('LLL')
                            },
                            {
                                margin: [10, 0, 0, 0],
                                text: this.name
                            }
                        ]
                    },
                    content: []
                }

                columns.forEach(function () {
                    table_widths.push('*')
                });
                this.documents.forEach(function (doc) {
                    pdf_table = []
                    console.log("DOC", doc)
                    doc.forEach(function(el){
                        if (el.metaData.question){
                            if (!el.value){
                                el.value = "NA"
                            }
                            pdf_table.push([el.metaData.question, el.value])
                        } else if (el.value.display_name) {
                            pdf_table.unshift(["Name", el.value.display_name])//TODO: this is too specific for a component, but figure out something better later
                        }
                    })
                        let content_obj = {
                            layout: 'lightHorizontalLines',
                            pageBreak: "after",
                            table: {
                                headerRows: 1,
                                widths: table_widths,
                                body: pdf_table
                            }
                        };
                        docDefinition.content.push(content_obj)
                })


                console.log("PDF_TABLE", pdf_table)

                console.log(docDefinition)
                pdfMake.createPdf(docDefinition).download(this.name + '.pdf');
            },
        },
        computed: {
            document: function() {
                if (this.documents.length == 0){
                    this.noData = true
                }
                console.log("COUNTER", this.counter)
                return this.documents[this.counter]
            },
            choiceParentQuestion: function() {
                console.log(typeof(this.document[0].metaData))
                let document = this.document.filter(document => typeof(document.metaData) == 'object');
                document = document.filter(document => document.metaData.parent == null)

                if (this.reverse){
                    return document.filter(document => document.metaData.question_type == 'choice').reverse()
                } else {
                    return document.filter(document => document.metaData.question_type == 'choice')
                }

            },
            metaDataObjects: function() {
                return this.document.filter(document => typeof(document.metaData) == 'object');
            },
            openResponse: function() {
                return this.metaDataObjects.filter(document => document.metaData.question_type == 'open')
            },
            basicMetrics: function() {
                return this.metaDataObjects.filter(document => document.metaData.question_type != 'open' &&
                    document.metaData.question_type != 'choice')
            },
            evenMetric: function() {
                return this.basicMetrics.filter((doc, i) => i%2 == 0)
            },
            oddMetric: function() {
                return this.basicMetrics.filter((doc, i) => i%2 != 0)
            },
            objectData: function() {
                return this.document.filter(document => typeof(document.value) == 'object' && document.value != undefined)
            },
            link: function() {
                return this.objectData.filter(document => 'slug' in document.value)
            }

        }
    }
</script>

<style scoped>
.survey-card{
    margin:30px;
}
    .justify-center{
        justify-content: center;
    }

    .cursor-pointer{
        cursor:pointer
    }

    .highlight-cell{
        font-weight: 900;
    }

    .question_option{
        text-align: center;
    }

    .child_question{
        background-color: #00D1B2 !important;
    }

</style>
